import { useEffect, useState } from 'react';

import ContentSlides from '../Components/ContentSlides';
import { useNotification } from '../Contexts/NotificationContext';

const HomeSlides = () => {
    const { setNotification } = useNotification();
    const [content, setContent] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/produtos-destaques`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setContent(data);
                } else {
                    throw new Error('Erro ao buscar o conteúdo');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchSlides();
    }, []);

    return (
        <>
            <ContentSlides content={content.recentes} url="/painel/produtos/" title="Recente" loading={loading} />
            <ContentSlides content={content.lancamentos} url="/painel/produtos/" title="Lançamentos" loading={loading} />
            {content.destaques &&
                content.destaques.map((item, index) => (
                    <ContentSlides
                        key={index}
                        content={item.produtos}
                        url={`/painel/produtos/${item.tipo_slug}/`}
                        seeAll={true}
                        anchor={item.slug}
                        title={item.nome}
                        loading={loading}
                    />
                ))}
            <ContentSlides content={content.mais_vistos} url="/painel/produtos/" title="Mais vistos" loading={loading} />
        </>
    );
};

export default HomeSlides;
